const Action = require("../../entities/Action");
const {Age}  = require("../Constants");
const ActionNames = require("../Names/ActionNames");

class EfficientUpgrade extends Action {
    constructor(age){
        super(
            age,
            ActionNames.EfficientUpgrade, 
            `Upgrade a farm, mine or urban building; pay ${EfficientUpgrade.GetResourceAmount(age)} resources less.`,
            {
                playerStateAltering:
                (playerState) => {
                    //Do stuff
                }
            },
            {}
        )
    }

    static GetResourceAmount(age){
        switch (age)
        {
            default:
                return null;
            case Age.Age2:
                return 3;
            case Age.Age3:
                return 4;
        }
    }
}

module.exports = EfficientUpgrade;